import React, { useState } from 'react'
import TextField from '../../../elements/form/TextField'
import TextareaField from '../../../elements/form/TextareaField'
import ModalActionButton from '../../../elements/ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR } from '../../../../store/types';
import { createExaminationCenter } from '../../../../store/actions/examinationCentersActions';
import AutocompleteSelect from '../../../elements/form/AutocompleteSelect';
import { parseNigerianStates, slugify } from '../../../../utils';
import { StatesLgas } from '../../../../assets/static/stateslgas';

const NewExaminationCenter = ({closeFunction}) => {
    const dispatch = useDispatch()
    const examinationCentersSelector = useSelector((state => state.examinationCenters))
    const [examCenterPayload, setExamCenterPayload] = useState({});
    const [validationErrors, setValidationErrors] = useState({});

    const [activeLgas, setActiveLgas] = useState([])
    const [lgasEnabled, setLgasEnabled] = useState(false)

    const selectState = (selectedState) => {
        setLgasEnabled(false)
        setActiveLgas(StatesLgas.find((state)=>{
            return state.stateSlug === slugify(selectedState.label)
        }).lgas)

        setTimeout(() => {
            setLgasEnabled(true)
        }, 50);

        setExamCenterPayload({...examCenterPayload, ...{state: selectedState.label}})
    }

    const validateForm = () => {
        let errors = {}
        if(!examCenterPayload.name || examCenterPayload.name === '') {
            errors.name = true
        }
        if(!examCenterPayload.description || examCenterPayload.description === '') {
            errors.description = true
        }
        if(!examCenterPayload.city || examCenterPayload.city === '') {
            errors.city = true
        }
        if(!examCenterPayload.state || examCenterPayload.state === '') {
            errors.state = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushCenter = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }
    
        dispatch(createExaminationCenter(examCenterPayload))
    }

    return (
        <div className='w-full'>
            <div className='mt-4'>
                <TextField
                    inputLabel="Examination center name" 
                    fieldId="center-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={examCenterPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setExamCenterPayload({...examCenterPayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Description" 
                    fieldId="center-description" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={examCenterPayload.description || ''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setExamCenterPayload({...examCenterPayload, ...{description: value}})}}
                />
            </div>

            <div className='mt-4'>
                <TextField
                    inputLabel="Address" 
                    fieldId="center-address" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={examCenterPayload.address || ''}
                    hasError={validationErrors && validationErrors.address} 
                    returnFieldValue={(value)=>{setExamCenterPayload({...examCenterPayload, ...{address: value}})}}
                />
            </div>

            <div className='mt-4'>
                <AutocompleteSelect
                    selectOptions = {parseNigerianStates()}
                    inputLabel = "State"
                    requiredField={true}
                    titleField = "label"
                    displayImage = {false}
                    imageField = ""
                    fieldId = "State"
                    preSelected={examCenterPayload.state || ''}
                    preSelectedLabel='value'
                    hasError = {validationErrors && validationErrors.state}
                    returnFieldValue={(value)=>{selectState(value)}}
                />
            </div>

            <div className='mt-4'>
                {lgasEnabled === true &&
                    <AutocompleteSelect
                        selectOptions = {activeLgas}
                        inputLabel = "Lga/City"
                        titleField = ""
                        displayImage = {false}
                        imageField = ""
                        disabled={!lgasEnabled}
                        fieldId = "userLga"
                        preSelected={examCenterPayload.lga || ''}
                        requiredField={true}
                        preSelectedLabel='value'
                        hasError = {validationErrors && validationErrors.city}
                        returnFieldValue={(value)=>{
                            console.log('selected value:: ', value)
                            setExamCenterPayload({...examCenterPayload, ...{ city: value }})}}
                />}
            </div>



            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create examination center`}
                    buttonAction={()=>{pushCenter()}}
                    processing={examinationCentersSelector.creatingExaminationCenter}
                 />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default NewExaminationCenter